import { render, staticRenderFns } from "./DepartmentConfig.vue?vue&type=template&id=97e065ea"
import script from "./DepartmentConfig.vue?vue&type=script&lang=js"
export * from "./DepartmentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports